import { InstantDoubleValue } from 'api/model/dataset/InstantDoubleValue'
import { useDatasetMappedValue } from 'hooks/useDatasetMappedValue';
import { DatasetDataInfo } from 'models/dataset-models'
import React from 'react'
import { formatDatasetValue } from 'utils/value-format-utils'

type DatasetDisplayValueProps = {
	dataset: DatasetDataInfo | undefined;
	data: InstantDoubleValue | null | undefined;
	loading: boolean;
	isData: boolean;
	truncateSize?: number;
};

const DatasetDisplayValue: React.FC<DatasetDisplayValueProps> = ({
	dataset,
	data,
	loading,
	isData,
	truncateSize = 10
}) => {
  const mappedValue = useDatasetMappedValue(dataset?.data[0]?.value, dataset?.stringValueMapper)
  
  if (loading || !dataset) {
    return (
      <span className='px-3 py-1'>
				<i className='pi pi-spin pi-spinner' />
			</span>
		);
	}
  
	if (!isData) {
		return (
			<>
				<span className='font-bold'>N/A</span>
				<span className='font-italic'> {dataset.unit}</span>
			</>
		);
	}

	if (dataset.stringValueMapper && !mappedValue){
		return (
      <span className='px-3 py-1'>
				<i className='pi pi-spin pi-spinner' />
			</span>
		);
	}

	if (dataset.stringValueMapper) {
		return (
			<span className='font-bold truncate-text' style={{maxWidth: `${truncateSize}ch`}}>
				{mappedValue}
			</span>
		);
	}

	return (
		<>
			<span className='font-bold'>{formatDatasetValue(dataset, data)}</span>
			<span className='font-italic'> {dataset.unit}</span>
		</>
	);
};


export default DatasetDisplayValue